import Cookies from 'js-cookie';

class BannerUtils {
    // From: https://github.schibsted.io/spt-dataanalytics/event-sdk-js/blob/master/ADID.md
    static getAdId() {
        const cookie =
            decodeURIComponent(
                document.cookie.replace(
                    new RegExp(
                        `(?:(?:^|.*;)\\s*${encodeURIComponent(
                            '_pulse2data'
                        ).replace(
                            /[-.+*]/g,
                            '\\$&'
                        )}\\s*\\=\\s*([^;]*).*$)|^.*$`
                    ),
                    '$1'
                )
            ) || false;
        if (cookie) {
            return cookie.split(',')[9];
        }
        return;
    }

    static getAbTestCookie() {
        const abTestCookie = Cookies.get('abtest');
        let activeAbTests = '';

        if (abTestCookie) {
            try {
                activeAbTests = Object.keys(JSON.parse(abTestCookie)).join(',');
            } catch (e) {
                if (window.trackJs) {
                    window.trackJs.track(`abtest cookie: ${abTestCookie}`);
                }
            }
        }
        return activeAbTests;
    }

    static getMarketPlace() {
        const segments = BannerUtils.getPathSegments();
        if (
            segments.length > 1 &&
            (segments.includes('search.html') ||
                segments.includes('browse.html') ||
                segments.includes('ad.html'))
        ) {
            // marketplace is only the top level "category", e.g. boat, car, mc etc.
            return segments[0];
        }
        return '';
    }

    static getPathSegments() {
        const url = new URL(document.baseURI);
        return url.pathname.split('/').filter(Boolean);
    }

    static isAdBlockerActive() {
        let adblockActive;
        const featureTest = document.getElementsByClassName('adsbox');
        if (featureTest && featureTest.length > 0) {
            adblockActive =
                window.getComputedStyle(featureTest[0]).display === 'none';
        }
        return adblockActive;
    }

    static getAppNexusData() {
        const appNexusMeta = document.querySelector(
            "meta[name='FINN.banner.appNexus']"
        );
        if (appNexusMeta && appNexusMeta.content) {
            return JSON.parse(decodeURIComponent(appNexusMeta.content));
        }
        return {};
    }

    static getElementByAdPosition(pos) {
        return document.querySelector(`[data-astbanner-name=${pos}]`);
    }

    static getAllVisbileTags() {
        const placementEles = document.querySelectorAll(
            'div[data-astbanner-name]'
        );
        const result = [];

        for (let i = 0; i < placementEles.length; i++) {
            const ele = placementEles[i];
            const tagId = ele.getAttribute(`data-astbanner-name`);
            const isHidden =
                ele.classList != null && ele.classList.contains(`hidden`);

            if (!isHidden) {
                result.push(tagId);
            }
        }
        return result;
    }

    static pageContains(ctx, tag) {
        return ctx.appNexusData.tags && ctx.appNexusData.tags[tag] != null;
    }

    static getSSAProductTag(allowedSSAProductTags) {
        let result = null;
        allowedSSAProductTags.forEach(ssaTag => {
            const element = document.getElementById(ssaTag);
            if (element && element.getAttribute('data-ssa-native') === 'true') {
                result = element;
            }
        });
        return result;
    }
}

export default BannerUtils;



// WEBPACK FOOTER //
// ./services/banner2/BannerUtils.js